import { render, staticRenderFns } from "./brightPoints.vue?vue&type=template&id=26f4d78c&scoped=true"
import script from "./brightPoints.vue?vue&type=script&lang=js"
export * from "./brightPoints.vue?vue&type=script&lang=js"
import style0 from "./brightPoints.vue?vue&type=style&index=0&id=26f4d78c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f4d78c",
  null
  
)

export default component.exports